import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="text-3xl font-semibold">Page not found</h1>
      <p className="text-muted-foreground">That page doesn't exist, or you don't have access to it.</p>
      <Button asChild>
        <Link to="/">Back to Hattie Automations</Link>
      </Button>
    </div>
  );
}
